import { render, staticRenderFns } from "./DPH.vue?vue&type=template&id=506f2662&scoped=true"
import script from "./DPH.vue?vue&type=script&lang=js"
export * from "./DPH.vue?vue&type=script&lang=js"
import style0 from "./DPH.vue?vue&type=style&index=0&id=506f2662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506f2662",
  null
  
)

export default component.exports